import { Provider } from "@/ui";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import CanvasLayout from "@/layouts/CanvasLayout";
import GeneralRootPage, { GeneralRootFooter } from "@/pages/GeneralRootPage";
import CanvasOverviewPage from "@/pages/project/CanvasOverviewPage";
import FocusAreaPage from "@/pages/project/FocusAreaPage";
import ActionPlanPage from "@/pages/project/ActionPlanPage";
import InsightsPage from "@/pages/project/InsightsPage";
import StandardLayout from "@/layouts/StandardLayout";
import LoginPage from "@/pages/LoginPage";
import LogoutPage from "@/pages/LogoutPage";
import AccessDeniedPage from "@/pages/AccessDeniedPage";
import AuthLayout from "@/layouts/AuthLayout";
import NotFoundPage from "@/pages/NotFoundPage";
import { PrivacyPolicyPage, TermsOfServicePage } from "@canucci/base-mantine/legal";
import { FrontendUpdatePrompt } from "@canucci/base-mantine/components";
import { CanvasLegalPage } from "@/components/legal/CanvasLegalPage";
const router = createBrowserRouter([
  {
    element: <AuthLayout />,
    errorElement: <NotFoundPage />,
    children: [
      {
        path: "/",
        element: (
          <StandardLayout darkBackground fullWidth footerContent={<GeneralRootFooter />} showFullscreen={false} />
        ),
        children: [{ index: true, element: <GeneralRootPage /> }],
      },
      {
        path: "/privacy-policy",
        element: <StandardLayout darkBackground fullWidth showHeader={false} showDecorations={false} />,
        children: [
          {
            index: true,
            element: (
              <CanvasLegalPage>
                <PrivacyPolicyPage accentHorizontalRules accentDocumentTitle accentSectionDividers accentEmailLinks />
              </CanvasLegalPage>
            ),
          },
        ],
      },
      {
        path: "/terms-of-service",
        element: <StandardLayout darkBackground fullWidth showHeader={false} showDecorations={false} />,
        children: [
          {
            index: true,
            element: (
              <CanvasLegalPage>
                <TermsOfServicePage accentHorizontalRules accentDocumentTitle accentEmailLinks />
              </CanvasLegalPage>
            ),
          },
        ],
      },
      {
        path: "/login",
        element: <LoginPage />,
      },
      {
        path: "/signup",
        element: <LoginPage />,
      },
      {
        path: "/logout",
        element: <LogoutPage />,
      },
      {
        path: "/access-denied",
        element: <AccessDeniedPage />,
      },
      {
        path: "/canvas",
        element: <CanvasLayout fullWidth={true} />,
        children: [
          {
            path: ":canvasId",
            element: <CanvasOverviewPage showHeader={true} />,
            handle: { pageId: "canvasOverview" },
          },
          {
            path: ":canvasId/action-plan",
            element: <ActionPlanPage />,
            handle: { pageId: "actionPlan" },
          },
          {
            path: ":canvasId/insights",
            element: <InsightsPage />,
            handle: { pageId: "insights" },
          },
          {
            path: ":canvasId/area/:groupIndex/:areaIndex",
            element: <FocusAreaPage />,
            handle: { pageId: "focusAreaGroup" },
          },
        ],
      },
      {
        path: "/participation",
        element: <CanvasLayout fullWidth={true} mode="participation" />,
        children: [
          {
            path: ":canvasId",
            element: <CanvasOverviewPage showHeader={true} />,
            handle: { pageId: "canvasOverview" },
          },
          {
            path: ":canvasId/area/:groupIndex/:areaIndex",
            element: <FocusAreaPage />,
            handle: { pageId: "focusAreaGroup" },
          },
        ],
      },
    ],
  },
]);

function AppRouter() {
  return (
    <Provider>
      <RouterProvider router={router} />
      <FrontendUpdatePrompt />
    </Provider>
  );
}

export default AppRouter;
